import api from './client';

export interface EnhancementOption {
  id: string;
  name: string;
  add_prompt: string;
  type_id: string;
  type_name: string;
  preview_description: string | null;
}

export interface CharacterEnhancement {
  id: string;
  type_id: string;
  type_name: string;
  option_id: string;
  option_name: string;
  acquired_at: string;
}

export interface LevelUpOptions {
  pending: boolean;
  level?: number;
  auto_apply: boolean;
  options: EnhancementOption[];
}

export interface LevelUpRequest {
  option_id?: string;  // Optional if auto_apply (single option)
}

export interface LevelUpResult {
  success: boolean;
  new_level: number;
  avatar_url: string;
  job_id?: string;
}

export interface LevelUpJobStatus {
  job_id: string;
  status: string;
  result?: { new_avatar_url: string; character_id: string };
  error?: string;
}

export interface LevelUpHistoryItem {
  level: number;
  option_name: string;
  avatar_url: string | null;
  created_at: string;
}

export const getPendingLevelUp = async (characterId: string): Promise<LevelUpOptions> => {
  const res = await api.get(`/api/characters/${characterId}/level-up`);
  return res.data;
};

export const submitLevelUp = async (
  characterId: string,
  optionId?: string
): Promise<LevelUpResult> => {
  const res = await api.post(`/api/characters/${characterId}/level-up`, { option_id: optionId });
  return res.data;
};

export const getLevelUpHistory = async (characterId: string): Promise<LevelUpHistoryItem[]> => {
  const res = await api.get(`/api/characters/${characterId}/history`);
  return res.data;
};

export const getCharacterEnhancements = async (characterId: string): Promise<CharacterEnhancement[]> => {
  const res = await api.get(`/api/characters/${characterId}/enhancements`);
  return res.data;
};

export const getLevelUpJobStatus = async (jobId: string): Promise<LevelUpJobStatus> => {
  const res = await api.get(`/api/characters/jobs/${jobId}`);
  return res.data;
};
